/**
 * Next.js 全局 custom image loader 入口（P1 接入）。
 * 由 common.next.config.js 的 images.loaderFile 引用。
 *
 * 签名符合 Next.js ImageLoader 规范（默认导出）：
 *   ({ src, width, quality }) => string
 *
 * gif 检测：从 src 扩展名静态判断，不走 imageView2 参数，避免动图首帧化。
 * 其余图片：追加 imageView2/2/w/{width}/q/{quality}/format/webp。
 */

import { nextImageLoader as _nextImageLoader } from './imageLoader';
import { migrateLog } from './utils/migrateLog';

export default function nextImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  migrateLog('image-loader', { src, via: 'next-image', params: { w: width, q: quality } });
  return _nextImageLoader({ src, width, quality });
}
